module.exports = __webpack_public_path__ + "img/banner-03.c988ea41.jpg";